import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    scrollTop: 0,
    screenHeight: 0,
    scrollHeight: 0,
    screenWidth: 0,
    hotWorkList: '',
    hotPostList: '',
    hotPosts: '',
    hotWorks: '',
    sloganInfo: '',
    serviceInfo: '',
    contactInfo: '',
    businessCope: '',
    textInfo: '',
    routerInfo: '',
    refresh: ''
  },
  getters: {
    scrollTop: state => state.scrollTop,
    screenWidth: state => state.screenWidth,
    scrollHeight: state => state.scrollHeight,
    screenHeight: state => state.screenHeight,
    // config, 热门文章, ids
    hotPosts: state => state.hotPosts,
    // data, 热门文章数据
    hotPostList: state => state.hotPostList,
    // data, 热门作品数据
    hotWorkList: state => state.hotWorkList,
    // config, 热门作品, ids
    hotWorks: state => state.hotWorks,
    // config, 公司描述
    sloganInfo: state => state.sloganInfo,
    // config, 服务配置
    serviceInfo: state => state.serviceInfo,
    // config, 联系配置
    contactInfo: state => state.contactInfo,
    // config, 业务范围
    businessCope: state => state.businessCope,
    // config, 首页文字描述
    textInfo: state => state.textInfo,
    // config, 路由配置
    routerInfo: state => state.routerInfo,
    // 是否刷新
    refresh: state => state.refresh
  },
  mutations: {
    // 热门文章数据
    updateHotPostList (state, data) {
      state.hotPostList = data
    },
    // 热门作品数据
    updateHotWorkList (state, data) {
      state.hotWorkList = data
    },
    // 热门文章配置
    updateHotPosts (state, data) {
      state.hotPosts = data
    },
    // 热门作品配置
    updateHotWorks (state, data) {
      state.hotWorks = data
    },
    // 公司标语
    updateSloganInfo (state, data) {
      state.sloganInfo = data
    },
    // 服务信息
    updateServiceInfo (state, data) {
      state.serviceInfo = data
    },
    // 地图和联系信息
    updateContactInfo (state, data) {
      state.contactInfo = data
    },
    // 路由配置
    updateRouter (state, data) {
      state.routerInfo = data
    },
    // 刷新
    updateRefresh (state, data) {
      state.refresh = data
    },
    // 业务范围
    updateBusinessCope (state, data) {
      state.businessCope = data
    },
    // 首页文字配置
    updateTextInfo (state, data) {
      state.textInfo = data
    },
    /*
    * 滑动距离
    */
    scrollToHeight (state, data) {
      state.scrollHeight = data
    },
    /*
    * 滚动离顶部的距离
    */
    scrollToTop (state, data) {
      state.scrollTop = data
    },
    /*
    * 窗口变化更新宽高
    */
    windowResize (state, data) {
      state.screenWidth = data.w
      state.screenHeight = data.h
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/utils/store.js